import { ExternalLink } from "lucide-react";

interface LandingLink {
  title: string;
  path: string;
  description: string;
}

const LANDING_PAGES: LandingLink[] = [
  {
    title: "Apartamentos Exclusivos com Vista para a Lagoa",
    path: "/lagoa/apartamentos-exclusivos-vista-lagoa-rodrigo-de-freitas-rj",
    description: "Hub da Lagoa Rodrigo de Freitas — conteúdo editável e imóveis selecionados.",
  },
  {
    title: "Os Melhores Imóveis de Ipanema",
    path: "/ipanema/melhores-imoveis-de-ipanema",
    description: "Hub de Ipanema — mesma estrutura da landing da Lagoa.",
  },
  {
    title: "Imóveis de Luxo na Lagoa",
    path: "/imoveis-de-luxo-na-lagoa",
    description: "Landing semântica de alto padrão na Lagoa.",
  },
  {
    title: "Apartamentos de 4 Quartos em Ipanema",
    path: "/apartamentos-4-quartos-ipanema",
    description: "Landing semântica focada em imóveis familiares.",
  },
  {
    title: "Studios para Airbnb em Copacabana",
    path: "/studios-airbnb-copacabana",
    description: "Landing semântica para investidores de renda por temporada.",
  },
  {
    title: "Apart Hotel Dias Ferreira — Leblon",
    path: "/leblon/apart-hotel-dias-ferreira",
    description: "Landing de empreendimento específico.",
  },
  {
    title: "Cobertura Parque das Rosas — Barra",
    path: "/barra-da-tijuca/cobertura-3-quartos-barra-parque-das-rosas",
    description: "Landing de imóvel exclusivo.",
  },
  {
    title: "Avaliação de Imóvel",
    path: "/avaliacao",
    description: "Landing de captação para avaliação gratuita.",
  },
  {
    title: "Anuncie seu Imóvel",
    path: "/anuncie-seu-imovel",
    description: "Landing de captação de proprietários.",
  },
];

const LandingPagesList = () => (
  <div className="bg-card rounded-lg border border-border p-6 mb-8">
    <h2 className="font-display text-lg font-bold text-foreground mb-1">Landing Pages Disponíveis</h2>
    <p className="text-sm text-muted-foreground mb-4">
      Todas as páginas de destino publicadas no site. Clique para abrir em uma nova aba.
    </p>
    <ul className="grid md:grid-cols-2 gap-3">
      {LANDING_PAGES.map((p) => (
        <li key={p.path} className="border border-border rounded-lg p-4 hover:border-gold transition">
          <a href={p.path} target="_blank" rel="noopener noreferrer" className="block">
            <span className="font-body font-semibold text-foreground flex items-center gap-2">
              {p.title} <ExternalLink className="h-3.5 w-3.5 text-gold" />
            </span>
            <span className="block text-xs text-muted-foreground mt-1">{p.description}</span>
            <span className="block text-xs text-navy mt-1 break-all">{p.path}</span>
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default LandingPagesList;
